/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientDemographics } from '../../models/patient-demographics';

export interface GlobalSettingsGet$Params {
}

export function globalSettingsGet(http: HttpClient, rootUrl: string, params?: GlobalSettingsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientDemographics>> {
  const rb = new RequestBuilder(rootUrl, globalSettingsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientDemographics>;
    })
  );
}

globalSettingsGet.PATH = '/api/GlobalSettings/patientdemographics/fetch';
